export default __webpack_public_path__ + "static/media/Group 3207@2x.79f5beea.png";